module.exports = __webpack_public_path__ + "static/media/tag_1.d2e795d9.svg";